import { ProductsDataContext, ProductsDataContextType } from "modules/cached-data/src/products-data/products-data-context"
import { useContext } from "react"

export function useProductsData (): ProductsDataContextType {
    return useContext( ProductsDataContext )
}
